<template>
  <div v-if="badge">
    <h4>
      <b-badge :variant="badge.variant">
        {{ $t("status") }} - {{ $t(badge.label) }}
      </b-badge>
    </h4>
  </div>
</template>

<script>
export default {
  name: "InvoiceStatus",
  props: ["status", "invoice"],
  computed: {
    badge() {
      const { status, invoice } = this;

      const map = {
        0: { variant: "success", label: "Open" },
        1: { variant: "success", label: "active_marketplace_offer"},
        2: { variant: "danger", label: "rejected" },
        5: { variant: "secondary", label: "click_sell_invoice" },
        6: { variant: "secondary", label: invoice?.is_reverse === 1 ? "supplier_confirmation_required" : "debtor_confirmation_required",},
        7: { variant: "danger", label: "rejected" },
        8: { variant: "success", label: "soon_goes_active" },
        10: { variant: "success", label: "sold" },
        11: { variant: "success", label: "settled" },
        13: { variant: "danger", label: "invoice_default" },
        14: { variant: "danger", label: "deactivated" },
        15: { variant: "warning", label: "removed_from_marketplace" },
        99: { variant: "danger", label: "removed" },
      };

      return map[status] || null;
    },
  },
};
</script>
